import { ApiResponseBill, Bill, mapApiToBill } from "./BillDetails";
import { ApiResponseInvoiceIssuanceDetails, InvoiceIssuanceDetails, mapApiToInvoiceIssuanceDetails } from "./InvoiceIssuanceDetails";

export interface ApiResponseBillsResponse {
  bills: ApiResponseBill[];
  issuanceDetails: ApiResponseInvoiceIssuanceDetails;
}

export interface BillingResponse {
  bills: Bill[];
  invoiceIssuanceDetails: InvoiceIssuanceDetails | null;
}

export const mapApiToBillingResponse = (
  apiData: ApiResponseBillsResponse
): BillingResponse => {
  return {
    bills: (apiData?.bills ?? []).map((bill) => mapApiToBill(bill)),
    invoiceIssuanceDetails: apiData?.issuanceDetails
      ? mapApiToInvoiceIssuanceDetails(apiData.issuanceDetails)
      : null,
  };
};